import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { IStyled } from '../../../styles/types';
import * as BuilderInfoUI from '../BuilderInfoUI';

interface IProps extends IStyled {
  items: string[];
  minWidth?: CSSProperties['minWidth'];
}

const Container = styled(BuilderInfoUI.BorderedInfo)`
  margin-right: 0;
`;

const BuilderInfoLabelList = ({ items, minWidth, className }: IProps) => {
  return (
    <Container style={{ minWidth: minWidth || 80 }} className={className}>
      {items.map((item) => (
        <BuilderInfoUI.StyledPopupLabel key={item}>
          {item}
        </BuilderInfoUI.StyledPopupLabel>
      ))}
    </Container>
  );
};

export default BuilderInfoLabelList;
